import { render, staticRenderFns } from "./MobileActivate.vue?vue&type=template&id=4cecf030&scoped=true&"
import script from "./MobileActivate.vue?vue&type=script&lang=js&"
export * from "./MobileActivate.vue?vue&type=script&lang=js&"
import style0 from "./MobileActivate.vue?vue&type=style&index=0&id=4cecf030&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cecf030",
  null
  
)

export default component.exports